/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

/**
 * The name of the cookie that contains the CSRF token.
 * @type {string}
 */
export const CSRF_COOKIE = '_csrf'

/**
 * The name of the HTTP header that contains the CSRF token.
 * @type {string}
 */
export const CSRF_TOKEN = 'csrf-token'
